<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <path fill-rule="evenodd" d="m7.488 9 4.63-4.631-1.237-1.238-5.868 5.87 5.868 5.868 1.238-1.238-4.631-4.63Z" clip-rule="evenodd"/>
</svg>
